<template>
    <div class="cursor_detail">
        <!-- cursorDefault.png  :src="url"-->
        <div class="cursor_inner" @click="handCkick">
            <el-image
            style="width: 100%; height: 200px; display: block"
            :src="cursorDetail.cover||defaultImg"
            fit="cover"
            ></el-image>
            <div class="cursor_content" :style="{height:dHeight+'px'}">
                <div class="equal" ref="equal">
                    <div class="title">
                        <h4>{{cursorDetail.title}}</h4>
                    </div>
                    <div class="detailed">
                        <span>共 {{(cursorDetail.classHours/60/45)==0?'0':(cursorDetail.classHours/60/45).toFixed(2)}} 学时</span>
                        <span :style="{color:Number(cursorDetail.classHours)>Number(cursorDetail.timeStudyed)?'#f40':'#3964E6'}">{{Number(cursorDetail.classHours)>Number(cursorDetail.timeStudyed)?'未学完':'已学完'}}</span>
                    </div>
                    <div class="end_time">结束时间：{{cursorDetail.endTimeS}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        cursorDetail:{
            type:Object,
            default:()=>{
                return {}
            }
        },
        dHeight:{
            type:Number,
            default:0
        }
    },
    data(){
        return {
            defaultImg: require("@/assets/images/cursorDefault.png"),
        }
    },
    mounted(){
        // 等高方法
        this.$nextTick(()=>{
            this.$emit('setEqual',this.$refs.equal.clientHeight)
        })
    },
    methods:{
        handCkick(){
            this.$emit('setHandleDetail',this.cursorDetail)
        },
    }
}
</script>
<style lang="scss" scoped>
.cursor_detail {
//   width: 33.33%;
  padding: 0 13px;
  margin-bottom: 50px;
  .cursor_inner{
      border:1px solid #999999;
      padding-bottom: 25px;
      border-radius: 10px;
      overflow: hidden;
      cursor: pointer;
      transition: all .3s;
      &:hover{
          transform: translateY(-6px);
          box-shadow: 2px 2px 6px  rgb(0 0 0 / 50%);
          border-color:#92a7e7;
      }
  }
  
}

.cursor_content {
  padding: 0px 10px;
  .equal{
      padding-top: 20px;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 10px;
    h4 {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 1.3;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
    }
  }
  .detailed{
    display: flex;
    justify-content: space-between;
    color: #999999;
    font-size: 14px;
  }
  .end_time{
    margin-top: 5px;
    color: #999999;
    font-size: 14px;
  }
}
</style>